
import { mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    mixins: [cms],
    data(){
        return {
            hoveredIndex: null,
        }
    },
    computed: {
        ...mapGetters({
            inviteAndEarnBanner: 'cms/inviteAndEarnBanner',
        }),
    },
}
